import Vue from "vue";
import VueRouter from "vue-router";
import Hydrate from "@/views/hydrate/index.vue";
import { getToken } from "plugins/utils";
import { pageView } from "plugins/segment";
const { VITE_WEB_URL } = import.meta.env;
import Redirect from "components/src/redirect.vue";

import Cards from "@/views/cards/List.vue";
import Card from "@/views/card/index.vue";
import CardCreate from "@/views/card/create.vue";
import Profile from "@/views/card/profile/index.vue";

import ContactList from "@/views/card/contacts/List.vue";
import ContactItem from "@/views/card/contacts/Item.vue";

import LinksList from "@/views/card/links/List.vue";
import LinksItem from "@/views/card/links/Item.vue";

import SocialLinksList from "@/views/card/social-links/List.vue";
import SocialLinksItem from "@/views/card/social-links/Item.vue";

import Welcome from "@/views/onboard/welcome.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    redirect: "/",
  },
  {
    path: "/",
    component: Hydrate,
    children: [
      {
        path: "welcome",
        name: "welcome",
        component: Welcome,
        meta: {
          label: "Welcome",
          breadcrumbs: [],
        },
      },
      {
        path: "",
        name: "cards",
        component: Cards,
        meta: {
          label: "Cards",
          breadcrumbs: ["cards"],
        },
      },
      {
        path: "+",
        name: "cards-create",
        component: CardCreate,
        meta: {
          label: "Create Card",
          breadcrumbs: ["cards", "cards-create"],
        },
      },
      {
        path: ":cardId",
        component: Card,
        props: true,
        meta: {
          label: "Cards",
          breadcrumbs: ["cards", "card"],
        },
        children: [
          {
            path: "",
            name: "card",
            component: Profile,
            props: true,
            meta: {
              label: "Card",
              breadcrumbs: ["cards", "card"],
            },
          },
          {
            path: "contacts",
            name: "contacts",
            component: ContactList,
            meta: {
              label: "Contacts",
              breadcrumbs: ["cards", "card", "contacts"],
            },
          },
          {
            path: "contacts/:id",
            name: "contact",
            component: ContactItem,
            props: true,
            meta: {
              label: "Contact",
              breadcrumbs: ["cards", "card", "contacts", "contact"],
            },
          },

          {
            path: "links",
            name: "links",
            component: LinksList,
            props: true,
            meta: {
              label: "Links",
              breadcrumbs: ["cards", "card", "links"],
            },
          },
          {
            path: "links/:id",
            name: "link",
            component: LinksItem,
            props: true,
            meta: {
              label: "Link",
              breadcrumbs: ["cards", "card", "links", "link"],
            },
          },

          {
            path: "social-links",
            name: "social-links",
            component: SocialLinksList,
            props: true,
            meta: {
              label: "Social Links",
              breadcrumbs: ["cards", "card", "social-links"],
            },
          },
          {
            path: "social-links/:id",
            name: "social-link",
            component: SocialLinksItem,
            props: true,
            meta: {
              label: "Social Links",
              breadcrumbs: ["cards", "card", "social-links", "social-link"],
            },
          },
        ],
      },
    ],
  },

  {
    path: "/redirect",
    name: "redirect",
    component: Redirect,
    meta: {
      public: true,
    },
  },
];

const router = new VueRouter({
  routes,
  mode: "hash",
});

/**========================================================================
 * *                              NOTE
 * We don't allow users from mobile devices hence, the first thing before
 * entering the route should be to check if it is mobile OS
 *========================================================================**/
router.beforeEach(async (from, to, next) => {
  // Download page pending
  // if (
  //   ["android", "ios"].includes(os) &&
  //   from.name != "download" &&
  //   from.name != "verify-account"
  // ) {
  //   next({
  //     name: "download",
  //   });
  // } else {
  if (from.params.id && from.params.id !== "+") {
    from.params.id = parseInt(from.params.id);
  }

  if (from.meta.public === true) {
    next();
  } else {
    if (getToken()) {
      next();
    } else {
      window.open(VITE_WEB_URL, "_self");
    }
  }
});

router.afterEach((to, from) => {
  if (router.app.isSubscriptionActive) {
    pageView(to, from);
  }

  localStorage.setItem("vp-last-path", to.path);
});

export default router;
